import { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from '@material-tailwind/react';
import Loader from '../../../Atoms/Loader';

export default function QueAccordion({ data, activeTab }) {
  const [open, setOpen] = useState(0);  
  const [visibleCount, setVisibleCount] = useState(5);
  const [expanded, setExpanded] = useState(false); 

  const handleOpen = (value) => {
    setOpen(open === value ? 100 : value);
  };

  function Icon({ id, open }) {
    return (
      <div>
        <FaChevronDown className={open === id ? 'rotate-180' : ''} />
      </div>
    );
  }

  const toggleVisibility = () => {
    if (expanded) {
      setVisibleCount(5);
    } else {
      setVisibleCount(data.length);
    }
    setExpanded(!expanded);
  };

  // useEffect(() => {
  //   console.log(data, activeTab);
  // }, []);

  return (
    <div className="max-w-screen-xl md:w-10/12 xl:w-8/12 mx-auto px-5">
      {data ? (
        <>
        {data.slice(0, visibleCount).map((item, index) => {
          return (
            <Accordion
              open={open === index}
              icon={<Icon open={open} id={index} />}
              key={index}
              className="border-b border-black border-opacity-20"
            >
              <AccordionHeader
                onClick={() => handleOpen(index)}
                className="font-poppins font-medium md:py-6 py-3 border-none"
              >
                <span className=" md:text-2xl text-base text-left normal-case md:pr-[5%]">
                  {item.question}
                </span>
              </AccordionHeader>
              <AccordionBody className="font-poppins h-fit md:pr-[10%] font-light text-base md:text-lg lg:text-xl xl:text-2xl mb-5">
                {item.answer}
              </AccordionBody>
            </Accordion>
          );
        })}
        {data.length > 5 && (
            <div className="text-center mt-4">
              <button
                onClick={toggleVisibility}
                className="px-6 py-2 bg-verde text-white font-medium rounded-md transition-all hover:bg-green-700 font-poppins"
              >
                {expanded ? 'Load Less' : 'Load More'}
              </button>
            </div>
          )}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
}
